import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const createReqLeaveSlice = createSlice({
  name: "createReqLeave",
  initialState,
  reducers: {
    createReqLeaveStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    createReqLeaveSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    createReqLeaveFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  createReqLeaveStart,
  createReqLeaveSuccess,
  createReqLeaveFailed,
} = createReqLeaveSlice.actions;

export default createReqLeaveSlice.reducer;
